const mobx = require("mobx");
const {observable} = mobx;
const {createTransformer} = require("mobx-utils");
const router = require("services/router");
const {toQueryString} = require("helpers/url");
const {decodeObservable} = require("helpers/object");
const assign = require("object-assign");
const shortid = require("shortid");

class PageContext {

    /////////////////////////////////
    // Init
    /////////////////////////////////

    @observable params = PageContext.paramsToObj();
    @observable globals = {};

    constructor() {
        mobx.autorun(this._updateUrl);

        // Essentially handle a navigation event as a new page load
        window.addEventListener('popstate', () => {
            this.params = PageContext.paramsToObj();
        });
    }

    static paramsToObj(params = null) {
        if (params === null) {
            params = new URLSearchParams(window.location.search);
        }

        let res = {};

        if (!(params instanceof URLSearchParams)) {
            throw 'Invalid search params in PageContext';
        }

        params.forEach((val, key) => res[key] = val); // TODO - might want to support arrays

        return res;
    }

    /////////////////////////////////
    // Private methods
    /////////////////////////////////

    _assign(obj) {
        const old = JSON.parse(JSON.stringify(this.params));

        this.params = (typeof obj === "function") ?
            obj(old) :
            assign(old, obj);
    }

    _updateUrl = () => {
        const query = Object.keys(this.params).length > 0 ?
            '?' + toQueryString(this.params) :
            '';
      
        const url = router.currentUrl + query;
        if (url !== location.href) {
            history.pushState('', '', window.location.href);
        }
    }

    /////////////////////////////////
    // Helpers
    /////////////////////////////////

    checkStep(name) {
        return this.params.step && this.params.step === name;
    }

    checkState(name) {
        return this.params.state && this.params.state === name;
    }

    startEditing(resource, id = null) {
        this._assign({
            state: 'editing',
            edit_uuid: shortid.generate(),
            [resource]: id,
        });
    }

    stopEditing(resource) {
        this._assign(params => {
            delete params[resource];
            delete params.state;
            delete params.edit_uuid;

            return params;
        });
    }

    handleTrigger(trigger) {
        let params = trigger.params || {};
        if (trigger.state) {
            params.state = trigger.state;
            if (params.state === 'editing') {
                params.edit_uuid = shortid.generate();
            }
        }
        if (trigger.resource && trigger.id) {
            params[trigger.resource] = trigger.id;
        }
        let url = router.route(trigger.route, null, params);
        location.href = url;
    }

    /////////////////////////////////
    // Constraints
    /////////////////////////////////

    @observable constraints = new Map();

    setConstraint(key, value) {
        this.constraints.set(key, value);
    }

    getConstraint = createTransformer(key => {
        return get(this.constraints, key);
    })

}

module.exports = new PageContext;
